export default __webpack_public_path__ + "static/birb-b8f663dfed1ce750e48cfd131b468386.png";